import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Grid,
  Container,
  CardMedia,
  Paper,
  useMediaQuery,
  AppBar,
  Toolbar,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Slide,
  useScrollTrigger,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const initialContent = {
  topTitle: "My Love, My Story",
  topText: "Welcome to Studio Art! We believe every love story is unique and deserves to be told beautifully. Our passion is capturing your most cherished moments with creativity and heart......",
  topImg: "https://images.unsplash.com/photo-1519125323398-675f0ddb6308",
  aboutText1: "Studio Art is a young and dynamic multimedia studio specializing in Ad film making, corporate visual making, wedding cinematic videography, and candid photography in Madurai, Trichy, Chennai, Salem, Coimbatore, Karur, Pondicherry, Bangalore.",
  aboutText2: "We are a team of passionate professionals dedicated to capturing the essence of your special moments through our lenses. With years of experience in the industry, we bring creativity, technical expertise, and a personal touch to every project we undertake.",
  aboutImg: "https://images.unsplash.com/photo-1465101046530-73398c7f28ca",
  midImg: "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
  midTitle: "Our Creative Vision",
  midText: "At Studio Art, we believe that every picture tells a story. Our creative vision is to capture the raw emotions, candid moments, and intricate details that make your event truly special. We strive to create timeless visual narratives that you will cherish forever.",
  ctaTitle: "Let's Capture Your Story Together!",
  ctaText: "Reach out to us for a personalized session or to discuss your upcoming event. We would love to be a part of your journey and help you create lasting memories.",
};

const NAV_LINKS = [
  { label: "Home", path: "/user-home" },
  { label: "Albums", path: "/user-albums" },
  { label: "Frames", path: "/user-frames" },
  { label: "Photo Selection", path: "/user-photo-selection" },
  { label: "Prices", path: "/user-prices" }, // <-- Make sure this is present!
  { label: "Contact", path: "/user-contact" },
  { label: "About", path: "/user-about" },
];

function HideOnScroll(props) {
  const { children } = props;
  const trigger = useScrollTrigger();
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

const UserAbout = () => {
  const [content, setContent] = useState(initialContent);
  const [footers, setFooters] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const clientMongoId = localStorage.getItem("clientMongoId");
  const isMobile = useMediaQuery("(max-width:600px)");
  const studioName = localStorage.getItem("studioName") ;

  useEffect(() => {
    async function fetchAboutPage() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/about-page`);
        if (res.data.aboutPage) setContent(res.data.aboutPage);
      } catch (err) {
        setContent(initialContent);
      }
    }
    fetchAboutPage();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchFooters() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`
        );
        setFooters(res.data.footers || {});
      } catch (err) {
        setFooters({});
      }
    }
    fetchFooters();
  }, [clientMongoId]);

  return (
    <Box sx={{ bgcolor: "#f9f7f3", minHeight: "100vh",mt: 7 }}>
      {/* Top Section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#e7dfd5",
          py: 6,
          px: 4,
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {/* Left Text */}
        <Box
          sx={{
            flex: 1,
            textAlign: "left",
            pr: { md: 4, xs: 0 },
            mb: { xs: 3, md: 0 },
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
               fontFamily: "Josefin Sans",
              mb: 2,
              color: "#8b5e3c",
              letterSpacing: 2,
            }}
          >
            {content.topTitle}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 400,
              fontFamily: "jost",
              color: "#5c4032",
              mb: 3,
              lineHeight: 1.6,
              maxWidth: 1000,
            }}
          >
            {content.topText}
          </Typography>
        </Box>
        {/* Right Portrait Image */}
        <Box
          sx={{
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: { xs: 220, md: 340 },
            width: { xs: 140, md: 520 },
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: 4,
            ml: { md: 4, xs: 0 },
            mr: { md: 10, xs: 0 },
            bgcolor: "#fff",
            position: "relative",
          }}
        >
          <img
            src={content.topImg}
            alt="Photographer"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "16px",
            }}
          />
        </Box>
      </Box>

      {/* About Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4} alignItems="center">
          {/* Left Text */}
          <Grid item xs={12} md={7}>
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.8,
                mb: 3,
                fontSize: 18,
               fontFamily: "Jost",
                color: "#5c4032",
                maxWidth: 600,
              }}
            >
              {content.aboutText1}
              <br />
              <br />
              {/* <span style={{ fontWeight: 800, color: "#8b5e3c", fontFamily: "Josefin Sans", }}>
                Studio Art is one of the Best Wedding Photography studios in Madurai.
              </span> */}
            </Typography>
            
          </Grid>
          {/* Right Image */}
          <Grid item xs={12} md={5}>
            <Box sx={{ position: "relative" }}>
              <Box
                component="img"
                src={content.aboutImg}
                alt="Wedding Couple"
                sx={{
                  width: "100%",
                  height: 340,
                  objectFit: "cover",
                  borderRadius: 4,
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          
        </Grid>
      </Container>

      {/* Mid Section */}
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4} alignItems="center">
          {/* Left Portrait Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: "relative",
                width: { xs: 340, md: 520 },
                height: { xs: 320, md: 340 },
                borderRadius: 4,
                overflow: "hidden",
                boxShadow: 3,
                bgcolor: "#fff",
                mx: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={content.midImg}
                alt="Photography"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "16px",
                }}
              />
            </Box>
          </Grid>

           <Grid item xs={12} md={7}>
           
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.8,
                fontSize: 18,
                fontFamily: "jost",
                color: "#5c4032",
                maxWidth: 600,
              }}
            >
              {content.aboutText2}
            </Typography>
          </Grid>
          
        </Grid>
      </Container>

      {/* Call to Action Section */}
      <Box sx={{ bgcolor: "#e7dfd5", py: 6, textAlign: "center" }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
           fontFamily: "Josefin Sans",
            color: "#8b5e3c",
            mb: 2,
            letterSpacing: 1,
          }}
        >
          {content.ctaTitle}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: "jost",
            fontSize: 18,
            color: "#5c4032",
            mb: 3,
          }}
        >
          {content.ctaText}
        </Typography>
      </Box>

      {/* AppBar, Drawer, and Footer remain unchanged below */}
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#fff",
            boxShadow: 3,
            height: isMobile ? 56 : 80,
            zIndex: 1201,
          }}
        >
          <Toolbar
            sx={{
              minHeight: isMobile ? 56 : 80,
              px: isMobile ? 1 : 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isMobile ? "space-between" : "center",
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
                 fontFamily: "Josefin Sans",
                fontWeight: 900,
                color: "#8b5e3c",
                letterSpacing: 2,
                mr: isMobile ? 0 : 4,
                flexShrink: 0
              }}
            >
              {studioName}
            </Typography>
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 4,
                  flexGrow: 1,
                }}
              >
                {NAV_LINKS.map((link) => (
                  <Button
                    key={link.label}
                    href={link.path}
                    sx={{
                      color: "#8b5e3c",
                       fontFamily: "Josefin Sans",
                      fontWeight: 700,
                      fontSize: 22,
                      textTransform: "none",
                      letterSpacing: 1.5,
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {isMobile && (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: "auto" }}
              >
                <MenuIcon sx={{ color: "#8b5e3c", fontSize: 36 }} />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 220, mt: 6 }}>
          <List>
            {NAV_LINKS.map((link) => (
              <ListItem
                button
                key={link.label}
                component="a"
                href={link.path}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: "#8b5e3c",
                     fontFamily: "Josefin Sans",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      {/* Footer Section */}
              {/* Footer Section */}
                       <Box
                              sx={{
                                bgcolor: "#a67c52",
                                color: "#fff",
                                 fontFamily: "Josefin Sans",
                                mt: 4,
                                pt: 4,
                                pb: 2
                              }}
                            >
                              <Grid container spacing={2} sx={{ maxWidth: 1300, mx: "auto" }}>
                                {/* Left Column */}
                                <Grid item xs={12} md={3} sx={{ml: { xs: 3 }, mt: { xs: 6,  }}}>
                                  <Typography variant="h5" sx={{ fontWeight: 700,  fontFamily: "Josefin Sans",  }}>
                                    {footers.studio}
                                  </Typography>
                                  <Typography variant="body1" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.tag}</Typography>
                                  <Typography variant="body2" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.handle}</Typography>
                                </Grid>
                                {/* Center Column */}
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    ml: { xs: 0, md: 12 }
                                  }}
                                >
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      textAlign: "center",
                                      fontSize: 18,
                                      mb: 2,
                                      fontFamily: "Jost",
                                    }}
                                  >
                                    {footers.text}
                                  </Typography>
                                </Grid>
                                {/* Right Column */}
                                <Grid item xs={12} md={3}>
                                  <Box sx={{ display: "flex", gap: 2, mb: 2,ml: { xs: 3, md: 15 } ,mt: { xs: 6, md: 5 } }}>
                                    {/* WhatsApp */}
                                    <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                                      <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                                      </Box>
                                    </a>
                                    {/* Instagram */}
                                    <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                                      <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                                      </Box>
                                    </a>
                                    {/* Gmail */}
                                    <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                                      <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                                      </Box>
                                    </a>
                                    {/* YouTube */}
                                    <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                                      <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                                      </Box>
                                    </a>
                                  </Box>
                                </Grid>
                                {/* Bottom Row */}
                                <Grid
                                  item
                                  xs={12}
                                  sx={{
                                    borderTop: "1px solid #fff2",
                                    mt: 0,
                                    ml: {xs:5, md:50},
                                    pt: 2,
                                    display: "flex",
                                    flexDirection: { xs: "column", md: "row" },
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                  }}
                                >
                                  <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                                    {footers.copyright}
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                                    {footers.made}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
    </Box>
  );
};

export default UserAbout;